import React from 'react'
import { options } from './options'
import { Row, Col, Typography } from 'antd'
import { useTranslation } from 'next-i18next'
import styles from './DepositListHeader.module.scss'
const { Title } = Typography

interface PropsType {
  depositsLength: number
}

const DepositListHeader = ({ depositsLength }: PropsType) => {
  const { t } = useTranslation()

  return (
    <>
      <Row>
        <Col lg={9} xs={24}>
          <Title level={5} className={styles['title']}>
            {t('general.ResultsLength', { length: depositsLength })}
          </Title>
        </Col>
        <Col lg={5} xs={24}>
          <options.FilterDepositInput />
        </Col>
        <Col lg={5} xs={24}>
          <options.FilterDepositByStatus />
        </Col>
        <Col lg={5} xs={24} className='has-text-centered'>
          <options.DepositMenuActions />
        </Col>
      </Row>
    </>
  )
}

export default DepositListHeader
